import instance from "../root.api";

export const getRiskTestRequest = () =>
    instance.get(`/risk-calculator`).then((response) => ({response}));

export const submitRiskRequest = ({answers}) =>
    instance
        .post(`/risk-calculator/calculate/v2`, {answers})
        .then((response) => ({response}));
